import React, { useMemo, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Layout,
  Checkbox,
  Row,
  Col,
  Form,
  Input,
  Select,
  Tooltip,
  Button,
  Popconfirm,
  Breadcrumb
} from "antd";
import { useTranslation } from "react-i18next";
import {
  InfoCircleOutlined,
  EditOutlined,
  DeleteOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
// import StepSider from "./StepSider";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { getRequest, postRequest } from "../../axios";
import { authUserData } from "../../utils/Helper";
import { ReactComponent as Archiveicon } from "../../image/Archiveicon.svg";
const onChange = (e) => {
  console.log(`checked = ${e.target.checked}`);
};
const { Content } = Layout;
const handleChange = (value) => {
  console.log(`selected ${value}`);
};
const ArchivedVendorList = () => {
  const navigate = useNavigate();
  const [arrow, setArrow] = useState("Show");
  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") {
      return false;
    }
    if (arrow === "Show") {
      return true;
    }
    return {
      pointAtCenter: true,
    };
  }, [arrow]);
  const colors = ["#094E8F"];

  const [vendor, setVendor] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, settotalCount] = useState(0);
  const [gstNo, setGstNo] = useState([]);
  const [reload, setReload] = useState(false);
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });
  const companyPercentage = authUserData()?.company_profile_perc
    ? authUserData()?.company_profile_perc
    : null;
  const { t } = useTranslation();
  useEffect(() => {
    const getVendorOnboardingArchiveList = async () => {
      setLoading(true);

      try {
        //  let apiResponse = await getRequest(`vendor-archive/?company_id=${CompanyId}`, state);
        let apiResponse = await getRequest(`vendor-archive/get-archive-vendor-company/`, state);
        console.log('api Res', apiResponse);
        if (apiResponse.status) {

          const sortedData = apiResponse.data.results.data.sort((a, b) => {
            console.log('a');
            return a.id - b.id;
          });
          setVendor(sortedData);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_archivelist"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    getVendorOnboardingArchiveList();
  }, [state, t]);


  const handleRestore = async (id) => {
    try {
      let apiResponse = await postRequest("vendor-archive/", {
        deleted: [id], // Send the ID in an array as expected by your API
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("vendor_onboarding_restore_successfully"));
        setReload(!reload); // Trigger reload of employee list
        navigate("/vendor"); // Navigate to the employee list page after restore
      } else {
        ErrorNotificationMsg(t("error_in_restore_vendor_onboarding"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };
  // const isComplete = companyPercentage === 100;

  const [companyProfileCount, setCompanyProfileCount] = useState(null);


  useEffect(() => {
    const fetchedData = authUserData()?.company_profile_count?.[0];
    if (fetchedData) {
      setCompanyProfileCount(fetchedData);
    } else {
      console.error("Company profile count data is missing or empty.");
    }
  }, [authUserData]);

  const incompleteModules = companyProfileCount
    ? Object.entries(companyProfileCount)
      .filter(([key, value]) => typeof value === "number" && value === 0)
      .map(([key]) => {
        switch (key) {
          case "company_material_perc":
            return "Company Material";
          case "site_location_perc":
            return "Site Location";
          case "user_role_perc":
            return "User Role";
          case "employee_perc":
            return "Employee";
          case "pr_release_perc":
            return "PR Release";
          case "business_setting_perc":
            return "Business Setting";
          case "vendor_perc":
            return "Vendor";
          default:
            return null;
        }
      })
      .filter((module) => module !== null)
    : [];

  const isComplete = incompleteModules.length === 0;
  return (
    <>
         <div className="ListingTopBar">
                    <div className="pagenamewrap">
                      <div className="pagename">
                      
                        <h3>Archive Vendor Onboarding</h3>
            
                        <Breadcrumb className="Breadcrumb-Sec">
                          <Breadcrumb.Item>
                            <Link to="/dashboard">Dashboard</Link>
                          </Breadcrumb.Item>
            <Breadcrumb.Item><Link to="/vendor">Vendor Onboarding</Link></Breadcrumb.Item>
                          <Breadcrumb.Item>Archive Vendor Onboarding</Breadcrumb.Item>
                        </Breadcrumb>
                        </div>
                    
                      
                    </div>
                  </div>
          <Content className="stepscontentwrap">
          
            <div className="stepsContent">

        
              <div className="cardswraper">
                <Row gutter={24}>
             
                  {vendor.map((vendor) => (
                    <Col xs={24} sm={24} md={12} xl={8} xxl={6} key={vendor.id}>
                      <div className="stepcard sitecard">
                        <div className="cardtitle">
                          {vendor.vendor_trade_name}
                          <div className="action">
                            {/* <Link
                              to={`/vendor/edit/${vendor.id}`}
                            >
                              <EditOutlined />
                            </Link> */}

                            {/* <DeleteOutlined /> */}
                            <Popconfirm
                              className="action"
                              title={t("are_you_sure_to_restore")}
                              okText={t("pop_ok")}
                              cancelText={t("pop_cancel")}
                              onConfirm={() => handleRestore(vendor.id)}
                            >
                              <DeleteOutlined  />
                                </Popconfirm>
                          </div>
                        </div>

                        <Row gutter={16}>
                          <Col xs={24}>
                            <Form.Item>
                              <label>Legal Name of Business </label>
                              <span className="value">
                                {" "}
                                {vendor.vendor_registered_name}
                              </span>
                            </Form.Item>
                          </Col>
                          <Col xs={24}>
                            <Form.Item>
                              <label>GSTN </label>
                              <span className="value"> {vendor.gst_no}</span>
                            </Form.Item>
                          </Col>
                          <Col xs={24}>
                            <Form.Item>
                              <label>Address </label>
                              <span className="value">
                                {vendor.trading_address_building}
                              </span>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            </div>

          </Content>
    
    </>
  );
};

export default ArchivedVendorList;
